export default __webpack_public_path__ + "static/media/3ac80de78255b3a5960a5ff5774bf5861581618169507.3c8ff8fd.webp";